import { hasSubscriptionFlag } from '@/data/flags/local-flags';
import { getCurrentTimezone } from '@/utils/moment-wrapper';
import {
    compileSegmentDefinition,
    getPipelineProps as getPipelinePropsFromMiddleware,
} from '@pendo/middleware';
import { hasSegmentFlag } from '@/data/flags/local-flags';

export async function getPipelineProps (segment) {
    const definition = segment.definition || { filters: [] };
    const { advancedOptions } = definition;
    const advancedOptionsWithConfig = withConfig(advancedOptions);

    const segmentWithConfig = {
        ...segment,
        definition: {
            ...definition,
            advancedOptions: advancedOptionsWithConfig,
        },
    };

    return getPipelinePropsFromMiddleware(segmentWithConfig);
}

function withConfig (configs = {}) {
    return {
        timeZone: getCurrentTimezone(),
        hasCompoundSegmentsFlag: hasSegmentFlag('compoundSegments'),
        hasShowAnonymousFlag: hasSubscriptionFlag('showAnonymous'),
        hasUsesSubaccountsFlag: hasSubscriptionFlag('usesSubaccounts'),
        ...configs,
    };
}

export function compile (filters, configs = {}) {
    return compileSegmentDefinition(filters, withConfig(configs));
}
